import React from 'react'
import styles from './ProcessTrack.module.scss'

export const ProcessTrack: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ol className={styles.track}>
    {React.Children.map(children, (child) => (
      <li className={styles.step}>{child}</li>
    ))}
  </ol>
)
